import angular from 'angular';
import { MeurhInclusaodependenteBeneficiosFormController } from './beneficios.form.controller';

export class MeurhInclusaodependenteBeneficiosFormComponent implements angular.IComponentOptions {
	static selector = 'meurhInclusaodependenteBeneficiosFormComponent';
	static controller = MeurhInclusaodependenteBeneficiosFormController;
	static template = require('!!html-loader!./beneficios.form.html');
	static transclude = true;
	static bindings = {
		entity: '=',
		form: '<',
		busy: '=',
		action: '<',
		exibeBtnAdicionar: '<',
	};
}
